import { ApiKeysTab } from '../phone/tabs/ApiKeysTab';
import { SectionFrame } from './SectionFrame';

export function ApiKeysSection() {
  return (
    <SectionFrame
      title="API-Schlüssel"
      description="Provider-Schlüssel im Secret Manager — Status und Update-Felder."
    >
      <ApiKeysTab />
    </SectionFrame>
  );
}
